<!--
 * =====================================================================
 * 작 업 명  : 사용자 목록
 * 파 일 명  : UserList.vue
 * 변경이력 
 * 2022-01-29 / 정태화 / 최초작성
 * =====================================================================
 -->
<template>
    <div>
        <button class="btn btn-dark mt-3" @click="search()">Search</button>
        <table class="table">
        <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col">Username</th>
            <th scope="col">Full name</th>
            <th scope="col">Phone</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item,index) in users" v-bind:key="item">
                <th scope="row">{{users.length - index}}</th>
                <td>{{item.USER_ID}}</td>
                <td>{{item.LAST_NAME}}{{item.FIRST_NAME}}</td>
                <td>{{item.MOBILE}}</td>
            </tr>
        </tbody>
        </table>
    </div>
</template>
<script>
    import { $global, $axios, $error } from "@/dot-ui/index.js";

    export default 
    {
        data() {
            return {
                users: [],
                fromParams: "",
            }
        },
        created() 
        {
            this.fromParams = $global.getUrlParams();
        },
        mounted()
        {
            this.search();
        },
        methods:
        {
            async search()
            {
                let fromSiteNo = this.fromParams.s;
                let fromCompNo = this.fromParams.c;
                let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/users";
                let response = await $axios.get(url, {}, true);
                let json = response.data;

                if (response.status == 200) {
                    this.users = json.items;

                } else {
                    $error.showMessage(response, this);
                }
            }
        }
    }
</script>
<style>

</style>
